<script setup>
import { useRouter } from 'vue-router'

const router = useRouter()

const backHome = () => {
  router.push('/').then(() => {
    location.reload()
  })
}
</script>

<template>
  <div class="empty-page">
    <a-result status="404" title="404" :sub-title="$t('home.error')">
      <template #extra>
        <a-button type="primary" @click="backHome">{{
          $t('home.backHome')
        }}</a-button>
      </template>
    </a-result>
  </div>
</template>

<style lang="scss" scoped>
.empty-page {
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
